import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen, MessageCircle } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import { ASSISTANCE_WHATSAPP, GUIDE_STEPS, waLink } from "../data/siteData";

export default function Guida() {
  return (
    <>
      <SEO
        title="Guida all'apertura del conto | Sisal Store"
        description="La guida passo passo per completare la registrazione del tuo conto gioco online."
      />
      <section data-testid="guida-page" className="bg-slate-50 py-16 sm:py-24">
        <div className="container-x max-w-4xl">
          <Reveal>
            <Link
              to="/conto-online"
              data-testid="guida-back-link"
              className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-slate-500 transition-colors hover:text-brand-dark"
            >
              <ArrowLeft className="h-4 w-4" />
              Torna al conto online
            </Link>
            <h1 className="mt-6 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl">
              Guida all'apertura del conto
            </h1>
          </Reveal>

          {GUIDE_STEPS.length === 0 ? (
            <Reveal delay={0.1}>
              <div className="mt-10 flex flex-col items-center gap-5 rounded-3xl border border-dashed border-slate-300 bg-white p-10 text-center sm:p-14">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-light text-brand-dark">
                  <BookOpen className="h-7 w-7" />
                </span>
                <h2 className="font-display text-xl font-bold uppercase tracking-tight text-ink">
                  La guida passo passo è in arrivo
                </h2>
                <p className="max-w-md text-sm leading-relaxed text-slate-500 sm:text-base">
                  Stiamo preparando una guida dettagliata per accompagnarti nella registrazione.
                  Nel frattempo, se hai dubbi, il nostro staff ti aiuta su WhatsApp.
                </p>
                <a
                  href={waLink(ASSISTANCE_WHATSAPP, "Ciao, ho bisogno di aiuto per la registrazione del conto gioco.")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="guida-whatsapp-btn"
                  className="btn btn-primary btn-lg"
                >
                  <MessageCircle className="h-5 w-5" />
                  CONTATTACI SU WHATSAPP
                </a>
              </div>
            </Reveal>
          ) : (
            <div className="mt-10 space-y-6">
              {GUIDE_STEPS.map((s, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <div className="card-soft p-7 sm:p-9">
                    <p className="overline-tag">Passaggio {i + 1}</p>
                    <h2 className="mt-2 font-display text-lg font-bold uppercase text-ink">{s.title}</h2>
                    <p className="mt-3 text-sm leading-relaxed text-slate-500 sm:text-base">{s.text}</p>
                    {s.image && (
                      <img src={s.image} alt={s.title} loading="lazy" className="mt-5 w-full rounded-2xl object-cover" />
                    )}
                  </div>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
